export const FALLBACK_DIAL_OPTIONS = [
  { value: "+971", label: "United Arab Emirates", cca2: "AE" },
  { value: "+966", label: "Saudi Arabia", cca2: "SA" },
  { value: "+974", label: "Qatar", cca2: "QA" },
  { value: "+973", label: "Bahrain", cca2: "BH" },
  { value: "+968", label: "Oman", cca2: "OM" },
  { value: "+965", label: "Kuwait", cca2: "KW" },
  { value: "+20", label: "Egypt", cca2: "EG" },
  { value: "+962", label: "Jordan", cca2: "JO" },
  { value: "+961", label: "Lebanon", cca2: "LB" },
  { value: "+92", label: "Pakistan", cca2: "PK" },
  { value: "+91", label: "India", cca2: "IN" },
  { value: "+44", label: "United Kingdom", cca2: "GB" },
  { value: "+1", label: "United States / Canada", cca2: "US" },
  { value: "+49", label: "Germany", cca2: "DE" },
  { value: "+33", label: "France", cca2: "FR" },
];

export function toFlagEmoji(cca2) {
  const code = String(cca2 || "").trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return "";
  const A = 0x1f1e6;
  return String.fromCodePoint(
    A + (code.charCodeAt(0) - 65),
    A + (code.charCodeAt(1) - 65),
  );
}

export function parseRestCountriesDialCodes(data) {
  const byDial = new Map();

  for (const country of Array.isArray(data) ? data : []) {
    const name = country?.name?.common || country?.name?.official;
    const cca2 = country?.cca2;
    const root = country?.idd?.root;
    const suffixes = country?.idd?.suffixes;
    if (!name || !root) continue;

    const suffixList =
      Array.isArray(suffixes) && suffixes.length > 0 ? suffixes : [""];

    for (const suffix of suffixList) {
      const dial = `${root}${suffix}`;
      if (!/^\+\d{1,5}$/.test(dial)) continue;

      const existing = byDial.get(dial);
      if (existing) {
        if (!existing.names.includes(name)) existing.names.push(name);
        continue;
      }
      byDial.set(dial, { value: dial, names: [name], cca2: cca2 || "" });
    }
  }

  return [...byDial.values()]
    .map((entry) => {
      const names = entry.names.sort((a, b) => a.localeCompare(b));
      const label =
        names.length > 2
          ? `${names.slice(0, 2).join(", ")} +${names.length - 2} more`
          : names.join(", ");
      return {
        value: entry.value,
        cca2: entry.cca2,
        label,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
}
